import { QuickstartTheme } from '../../types/theme';
import { ThemeLogo } from '../ThemeLogo';
import { IconDropTrimmedLogo } from './IconDropTrimmedLogo';
import { resolveIconDropLogoSizes } from './iconDropLogoSize';
import { ICON_DROP_BRAND_TOP, ICON_DROP_PX, iconDropPx, iconDropScaled } from './iconDropScale';

interface IconDropBrandClusterProps {
  theme: QuickstartTheme;
  /** Play Again interstitial only — do not enable on other Icon Drop screens. */
  trimLockup?: boolean;
  /** Campaign opt-outs from the CTA/thank-you screens (hideStudioLogoOnCTA). */
  hideStudio?: boolean;
  hideGame?: boolean;
}

/**
 * Studio mark over game mark, centred in the upper third.
 *
 * Studio max-height is 30% of the game mark's layout/slot height (theme /
 * artboard, default 160). Width is half the game mark so square (STF) and
 * OVERKILL stay height-limited while Jagex stays about half the game logo.
 */
export const IconDropBrandCluster = ({ theme, trimLockup = false, hideStudio = false, hideGame = false }: IconDropBrandClusterProps) => {
  const sizes = resolveIconDropLogoSizes(theme);
  const Logo = trimLockup ? IconDropTrimmedLogo : ThemeLogo;

  return (
    <div
      className='absolute inset-x-0 z-10 flex -translate-y-1/2 flex-col items-center'
      style={{ top: ICON_DROP_BRAND_TOP, gap: iconDropPx(ICON_DROP_PX.brandGap) }}
    >
      {!hideStudio && (
        <Logo
          kind='thankYouStudio'
          theme={theme}
          className='icon-drop-studio-logo'
          style={{
            width: 'auto',
            height: 'auto',
            maxWidth: iconDropScaled(sizes.studioMaxWidthFraction),
            maxHeight: iconDropPx(sizes.studioHeight),
            objectFit: 'contain',
          }}
        />
      )}
      {!hideGame && (
        <Logo
          kind='game'
          theme={theme}
          className='icon-drop-game-logo'
          style={{
            height: iconDropPx(sizes.gameHeight),
            maxWidth: iconDropScaled(sizes.gameMaxWidthFraction),
          }}
        />
      )}
    </div>
  );
};
